module.exports = __webpack_public_path__ + "static/media/SUGERENCIAS PARA PADRES Y MADRES.cde3708a.pdf";